import { load } from 'cheerio';
import IPrice from '@/interfaces/IPrice';
import Provider from '@/enums/Provider';

export function extractProductPrice(
  htmlSource: string,
  provider: Provider
): IPrice {
  const $ = load(htmlSource);
  // Extract the price from JSON-LD first (primary source)
  const jsonLdData = $('script[type="application/ld+json"]').html();
  let price = '';
  let onOffer = false;
  let priceExcVat = '';
  switch (provider) {
    case Provider.KBS:

      if (jsonLdData) {
        const jsonData = JSON.parse(jsonLdData);
        price = jsonData.offers?.price || '';
      }

      // Extract the onOffer from the table
      $('table.table-striped tr').each((i, elem) => {
        const row = $(elem).find('th').text();
        if (row.includes('Old Price')) {
          onOffer = true;
        }
      });

      // Extract the priceExcVat from the table
      $('table.table-striped tr').each((i, elem) => {
        const col = $(elem).find('td').text();
        if (col.includes('VAT')) {
          priceExcVat = $(elem).find('td').text();
        }
      });
      break;
    case Provider.IO: {
      // io_product_price_top_left as a backup use io_product_price_box if the first one is not available
      const selectors = [
        '.io_product_price_top_left',
        '.io_product_price_box',
        '.io_product_price',
        '.io_product_price_top',
        '.io_product_price_bottom'
      ];
      let priceElem;
      for (const selector of selectors) {
        const elem = $(selector).first();
        if (elem.length) {
          priceElem = elem;
          break;
        }
      }
      price = priceElem?.text().trim().replace('$', '').replace(/,/g, '') || '';

      break;
    }
    case Provider.ERS: {
      const priceElem = $('.item_price').first()
        || $('.pricing-rules-body').first()
        || $('td:contains("$")').first();

      price = priceElem?.text().trim().replace('$', '').replace(/,/g, '') || '';

      // Check for strike element or pricing tables for offers
      onOffer = priceElem.parent().prev().find('strike').length > 0
        || $('td:contains("BEST DEAL")').length > 0;

      // VAT information not shown
      priceExcVat = '';
      break;
    }
    default:
      break;
  }
  // Return the price object
  return { price, priceExcVat, onOffer };
}
